var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import BaseApiClient from '@/plugins/apis/v2/base-api-client';
var UnitTypeApiClient = /** @class */ (function (_super) {
    __extends(UnitTypeApiClient, _super);
    function UnitTypeApiClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UnitTypeApiClient.prototype.fetchUnitTypes = function () {
        var client = this.client;
        return client.get('/unit_types');
    };
    return UnitTypeApiClient;
}(BaseApiClient));
export default new UnitTypeApiClient();
